<template>
  <div class="estimate" v-if="evaluationState.popup">
    <div class="estimate_bg"></div>
    <div class="estimate_box">
      <div class="estimate_colse" @click="colseEstimate">
        <img
          class="estimate_colse_img"
          :src="require('@/img/' + getTheme + '-close.png')"
          alt=""
        />
        <!-- <img
          class="estimate_colse_img"
          v-if="getTheme == 1"
          src="@/img/kpclose.png"
          alt=""
        />
        <img class="estimate_colse_img" v-else src="@/img/colse.png" alt="" /> -->
      </div>
      <div class="estimate_text">
        {{ $t("estimate.text") }}
      </div>
      <div class="estimate_url" v-if="evaluationState.data">
        <img class="estimate_img" :src="evaluationState.data.icon" alt="" />
      </div>
      <div class="estimate_title" v-if="evaluationState.data">
        {{ evaluationState.data.gamename }}
      </div>

      <div class="estimate_click">
        <div
          class="estimate_click_url"
          v-for="(item, index) in 5"
          @click="select(index)"
          :key="index"
        >
          <img
            class="estimate_click_img"
            v-if="estimateIndex >= index"
            src="@/img/heart-02.png"
            alt=""
          />
          <img
            class="estimate_click_img"
            v-else
            src="@/img/heart-01.png"
            alt=""
          />
        </div>

        <!--      <img src='@/img/heart-01.png' alt="">
          <img src='@/img/heart-01.png' alt="">
          <img src='@/img/heart-01.png' alt="">
          <img src='@/img/heart-01.png' alt=""> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
export default {
  data() {
    return {
      estimateURL: "",
      estimateIndex: -1,
      getTheme: 0
    };
  },
  created() {
    this.getTheme = configs.getTheme();
  },
  computed: {
    ...mapState("game", ["evaluationState"])
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", ["commitUserGameEvaluation", "setCloseEvaluation"]),
    // 点击选择按钮
    select(index) {
      if (this.estimateIndex == index) {
        this.estimateIndex = -1;
        return;
      }
      this.estimateIndex = index;
      if (index >= 0) {
        this.getCommitUserGameEvaluation(index);
      }
    },

    // 评价关闭
    colseEstimate() {
      this.getCommitUserGameEvaluation(0);
      // this.$emit("setEstimateModel", false);
      // localStorage.removeItem("ShareGame");
      // localStorage.removeItem("Sharetime");
      // this.showShare = false;
    },

    //
    async getCommitUserGameEvaluation(index) {
      const self = this;
      setTimeout(() => {
        self.closeEvaluation();
      }, 500);
      const res = await this.commitUserGameEvaluation({
        $axios: this.$axios,
        gameId: this.evaluationState.data.gameId,
        userEvaluationScore: index + 1,
        type: this.evaluationState.type
      });
      if (res.stateCode == 1) {
        this.tipMessage({ context: this.$t("estimate.toast") });
      }
    },
    // 关闭页面
    closeEvaluation() {
      this.setCloseEvaluation();
    }
  }
};
</script>

<style scoped="scoped">
.estimate {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.estimate_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.estimate_box {
  position: relative;
  z-index: 2;
  width: 8rem;
  height: 7.5rem;
  background-color: var(--estimateBackground);
  border-radius: 0.45rem;
}
.estimate_colse {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.29rem 0.24rem;
}
.estimate_colse_img {
  width: 0.73rem;
  height: 0.73rem;
}
.estimate_url {
  position: relative;
  width: 2.18rem;
  height: 2.18rem;
  margin: 0.46rem auto 0;
}
.estimate_img {
  box-sizing: border-box;
  object-fit: cover;
  width: 2.18rem;
  height: 2.18rem;
  border-radius: 0.2rem;
  border: 0.06rem solid #ffffff;
  box-shadow: 0px 0.07rem 0.15rem 0px rgba(0, 0, 0, 0.2);
}
.estimate_title {
  margin-top: 0.21rem;
  text-align: center;
  font-size: 0.48rem;
  color: var(--estimateGameTextColor);
}
.estimate_text {
  margin-top: 1.24rem;
  font-size: 0.48rem;
  color: var(--estimateTextColor);
  padding: 0 1rem;
  text-align: center;
  font-weight: bold;
}
.estimate_click {
  position: absolute;
  bottom: 0.91rem;
  width: 100%;
  height: 0.74rem;
  /* margin-top: 0.6rem; */
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
}
.estimate_click_url {
  width: 0.79rem;
  height: 0.72rem;
}
.estimate_click_img {
  width: 0.79rem;
  height: 0.72rem;
}
</style>



// WEBPACK FOOTER //
// src/components/model/estimate.vue